import {
    InboundGoodsLot,
    IncomingDetailArrivalDialogProps,
    IncomingDetailData,
    PoGoodsShelf
} from '../../../types/inbound'
import { Dialog } from 'primereact/dialog'
import React, { useContext, useEffect, useState } from 'react'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import { InputNumber } from 'primereact/inputnumber'
import { Dropdown } from 'primereact/dropdown'
import { Calendar } from 'primereact/calendar'
import moment from 'moment'
import { useMountEffect } from 'primereact/hooks'
import { cloneDeep, isEqual, max, sumBy, groupBy } from 'lodash'
import { CommonContext } from '../../common/context/commonContext'
import { ScrollPanel } from 'primereact/scrollpanel'
import { classNames } from 'primereact/utils'
import usePreventRefresh from '../../../utils/usePreventRefresh'
import useBlockBackNavigation from '../../../utils/useBlockBackNavigation'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'
import { Checkbox } from 'primereact/checkbox'

//입하처리
const goodsOrdUnitTypes = [
    {
        codeId: 'EA',
        codeNm: 'EA',
        displayNm: 'EA',
        fltrCd: undefined,
        chainCode: '',
        codeGroupId: 'GD_ORD_TYP',
    },
    {
        codeId: 'PK',
        codeNm: 'PK',
        displayNm: 'PK',
        fltrCd: undefined,
        chainCode: '',
        codeGroupId: 'GD_ORD_TYP',
    },
    {
        codeId: 'BOX',
        codeNm: 'BOX',
        displayNm: 'BOX',
        fltrCd: undefined,
        chainCode: '',
        codeGroupId: 'GD_ORD_TYP',
    },
    {
        codeId: 'KG',
        codeNm: 'KG',
        displayNm: 'KG',
        fltrCd: undefined,
        chainCode: '',
        codeGroupId: 'GD_ORD_TYP',
    },
]

const IncomingDetailArrivalDialog = (props: IncomingDetailArrivalDialogProps) => {
    const { $toast, $http, $alert } = useContext(CommonContext)
    const { t } = useTranslation()
    const [cloneData, setCloneData] = useState<IncomingDetailData>()
    const [activeShelf, setActiveShelf] = useState<PoGoodsShelf>()
    const [filterTypes, setFilterTypes] = useState<any>([])
    const [confirmDisabled, setConfirmDisabled] = useState<boolean>(false)
    const [deleteDisabled, setDeleteDisabled] = useState<boolean>(false)
    const [saveBlock, setSaveBlock] = useState<boolean>(false)
    const [goodsLotList, setGoodsLotList] = useState<InboundGoodsLot[]>([])

    usePreventRefresh()
    useBlockBackNavigation()

    // LOT 정보 가져오기
    const fetchGoodsLot = async () => {
        try {
            const { goodsLotList } = await $http().get(`/inbound/${props.data.goodsId}/goods-lot`)
            if (goodsLotList) {
                setGoodsLotList(goodsLotList)
            }
        } catch (error) {
            $alert({
                icon: 'error',
                title: t(tokens.error.inbound_lot_error_title),
                text: t(tokens.error.inbound_lot_error_text),
            })
        }

    }

    useMountEffect(() => {
        fetchGoodsLot()
    })

    useEffect(() => {
        if (!props.data) return

        const { checkShelfs, waitShelfs, ...result } = props.data
        const data = {
            ...result,
            waitShelfs: cloneDeep([
                ...waitShelfs.map((shelf) => {
                    return {
                        ...shelf,
                        shlfYmd: shelf.shlfYmd,
                    }
                }),
            ]),
            checkShelfs: cloneDeep([
                ...checkShelfs.map((shelf) => {
                    let checkLotNo = props.data.shlfYn === "Y" && !props.isUpdate ? undefined : shelf.lotNo;
                    // 예정서에 등록된 유통기한(shelf.shlfYmd)을 기본 날짜로 사용한다.
                    let checkShlfYmd = shelf.shlfYmd;

                    // 입하 처리 시 goodsLotList에서 빈 LOT 찾아서 LOT 번호만 설정 (유통기한은 예정값 유지)
                    if (props.data.shlfYn === 'Y' && !props.isUpdate) {
                        const emptyLot = goodsLotList.find(lot => !lot.lotNo?.trim());
                        if (emptyLot) {
                            checkLotNo = emptyLot.lotNo || ''
                        }
                    }

                    return {
                        ...shelf,
                        lotNo: checkLotNo,
                        shlfYmd: checkShlfYmd,
                        // cnfrGoodsQty: shelf.cnfrGoodsQty ? shelf.cnfrGoodsQty : shelf.goodsQty,
                        // cnfrShlfYmd: shelf.cnfrShlfYmd
                        //    ? moment(shelf.cnfrShlfYmd, 'YYYYMMDD').toDate()
                        //    : moment(shelf.shlfYmd, 'YYYYMMDD').toDate(),
                    }
                }),
            ]),
        }
        console.log('useMountEffect-CloneData', data)
        setCloneData(data)

        setFilterTypes(
            goodsOrdUnitTypes.filter((unitType) => {
                switch (props.data.gdslsUnitCd) {
                    case 'PK':
                        return unitType.codeId === 'PK' || unitType.codeId === 'BOX'
                    case 'EA':
                        return unitType.codeId === 'EA' || unitType.codeId === 'BOX'
                    case 'BOX':
                        return unitType.codeId === 'BOX'
                    case 'KG':
                        return unitType.codeId === 'KG' || unitType.codeId === 'BOX'
                    default:
                        return null
                }
            }),
        )
        checkConfirm(data)
    }, [goodsLotList, props.data, props.isUpdate])

    const onChangeData = (shelf: PoGoodsShelf, type: 'goodsQty' | 'cnfrUnitCd' | 'shlfYmd' | 'lotNo', value: any) => {
        const gdslsUnitCd = props.data.gdslsUnitCd
        const boxInbQty = props.data.boxQty
        switch (type) {
            case 'goodsQty':
                shelf[type] = value as number
                // 판매단위 수량 맞춰서 적용
                if (shelf.cnfrUnitCd === gdslsUnitCd) {
                    shelf.gdslsQty = value
                } else {
                    shelf.gdslsQty = value * boxInbQty
                }
                break
            case 'cnfrUnitCd':
                shelf[type] = value as string
                // 판매단위 수량 맞춰서 적용
                if (shelf.cnfrUnitCd === gdslsUnitCd) {
                    shelf.gdslsQty = shelf.goodsQty
                } else {
                    if (shelf.goodsQty === undefined) {
                        shelf.gdslsQty = 0
                    } else {
                        shelf.gdslsQty = shelf.goodsQty * boxInbQty
                    }
                }
                break
            case 'shlfYmd':
                shelf[type] = moment(value as Date).format('YYYYMMDD')
                // shelf[type] = value as string
                break
            case 'lotNo':
                shelf[type] = value as string;
                const matchedLot = goodsLotList.find(lot => lot.lotNo === value)
                if (matchedLot) {
                    shelf.shlfYmd = matchedLot.shlfYmd
                }
                break
        }
        console.log('onChangeData', shelf)
        const { prSeq, seq } = shelf

        if (cloneData && cloneData.checkShelfs) {
            cloneData.checkShelfs[cloneData.checkShelfs.findIndex((data) => data.prSeq === prSeq && data.seq === seq)] = shelf
        }

        const deep = cloneDeep(cloneData)
        setCloneData(deep)
        checkConfirm(deep)
    }

    const checkConfirm = (checkData: IncomingDetailData | undefined) => {
        if (checkData && checkData.checkShelfs) {
            // 유효한 항목(삭제되지 않은 항목)을 필터링
            const validShelfs = checkData.checkShelfs.filter((shelf) => shelf.delYn === 'N')

            // 유효한 항목의 수가 1개 이하일 경우 버튼 비활성화
            const isSingleOrLess = validShelfs.length < 1

            const impossibleConfirm =
                checkData.shlfYn === 'Y'
                    ? checkData.checkShelfs.some((shelf) => shelf.delYn === 'N' && (!shelf.goodsQty || !shelf.cnfrUnitCd || !shelf.shlfYmd))
                    : checkData.checkShelfs.some((shelf) => shelf.delYn === 'N' && (!shelf.goodsQty || !shelf.cnfrUnitCd))

            const impossibleQty: boolean = checkData.checkShelfs.some(
                (shelf) => (shelf.gdslsQty !== undefined && !(shelf.gdslsQty >= 0)) || (shelf.goodsQty !== undefined && !(shelf.goodsQty >= 0)),
            )

            setConfirmDisabled(isSingleOrLess || impossibleConfirm || impossibleQty)
        }
    }

    const onClickSave = async () => {
        if (!cloneData) return

        setSaveBlock(true)

        // 예정 수량과 실입고 수량은 주문단위 수량으로 변환하여 차이를 계산한다.
        const waitGoodsQty = cloneData.waitShelfs.reduce((qty, data) => {
            if (data.gdslsQty !== undefined) {
                return qty + data.gdslsQty
            }
            return qty
        }, 0)
        const checkGoodsQty = cloneData.checkShelfs.reduce((qty, data) => {
            if (data.delYn === 'Y') return qty
            if (data.gdslsQty !== undefined) {
                return qty + data.gdslsQty
            }
            return qty
        }, 0)

        const unitCds = groupBy(
            cloneData.checkShelfs.filter((v) => v.shlfYmd !== undefined),
            function (v) {
                return v.cnfrUnitCd
            },
        )

        let totalInfo = ''
        for (const key in unitCds) {
            const sumQty = sumBy(
                unitCds[key].filter((v) => v.delYn !== 'Y'),
                'goodsQty',
            )
            totalInfo += sumQty + ' (' + key + ') '
        }
        // 예정수량보다 적치수량이 많은 경우
        if (waitGoodsQty < checkGoodsQty) {
            await $alert({
                icon: 'info',
                title: t(tokens.common.confirmation_of_arrival_processing),
                text: t(tokens.inbound.greater_than_expected_quantity_received),
            })
            setSaveBlock(false)
            return
        }

        const isConfirm = await $alert({
            icon: 'info',
            title: t(tokens.inbound.admission_processing),
            text:
                waitGoodsQty > checkGoodsQty
                    ? t(tokens.inbound.receipt_plan_differs_from_info)
                    : t(tokens.inbound.confirm_receipt_total_info, { total: totalInfo }),
            isConfirm: true,
        })

        if (isConfirm) {
            // console.log(cloneData)
            const req = {
                ...cloneData,
                shelfs: cloneData.checkShelfs.map((shelf) => {
                    return {
                        ...shelf,
                        shlfYmd: props.data.shlfYn === 'Y' ? moment(shelf.shlfYmd).format('YYYYMMDD') : '99991231',
                    }
                }),
            }

            const result = await $http().put('/inbound/incoming-keep', req)

            if (result) {

                $toast({
                    title: t(tokens.common.success),
                    text: t(tokens.common.complete_arrival_processing),
                    icon: 'success'
                })

                const newLotList = req.shelfs
                    .filter(reqShelf =>
                        !goodsLotList.some(goodsLot =>
                            goodsLot.lotNo === reqShelf.lotNo &&
                            goodsLot.shlfYmd === reqShelf.shlfYmd
                        )
                    )

                    .map(reqShelf => ({

                        goodsId: props.data.goodsId,
                        lotNo: reqShelf.lotNo ?? '',
                        shlfYmd: reqShelf.shlfYmd,
                    }))

                await handleSaveLot(newLotList);

            }

            props.onHide(true)
        }

        setSaveBlock(false)
    }

    const handleSaveLot = async (newLotList: any[]) => {

        if (newLotList.length === 0) return

        const confirmSaveLot = await $alert({
            icon: 'info',
            title: t(tokens.inbound.lot_save_title),
            text: t(tokens.inbound.lot_save_text),
            isConfirm: true,
        })

        if(confirmSaveLot) {
            try {
                const saveResult = await $http().post(`/inbound/${props.data.goodsId}/goods-lot`,  {
                    goodsLotList: newLotList,
                })

                if (saveResult) {
                    $toast({
                        title: t(tokens.inbound.lot_save_success_title),
                        text: t(tokens.inbound.lot_save_success_text),
                        icon: 'success'
                    })
                }
            } catch (error) {
                $toast({
                    title: t(tokens.error.inbound_lot_save_error_title),
                    text: t(tokens.error.inbound_lot_save_error_text),
                    icon: 'error'
                })
            }
        }


    }

    const onClickAdd = () => {
        const clone = cloneDeep(cloneData)
        if (clone && clone.checkShelfs) {
            const seqs = clone.checkShelfs.map((shelf) => shelf.seq)
            const nextSeq = seqs.length > 0 ? (max(seqs) || 1 + 1) + 1 : 1

            let lotNo: string | undefined = undefined
            let shlfYmd: string | undefined = undefined

            //항목추가 할 경우에 기본 저장된 LOT값이 빈값이면 셋팅
            if (goodsLotList.length > 0) {
                const emptyLot = goodsLotList.find(lot => lot.lotNo === '')
                if (emptyLot) {
                    lotNo = emptyLot.lotNo
                    shlfYmd = emptyLot.shlfYmd
                }
            }

            const nextShelf = {
                prSeq: clone.prSeq,
                seq: nextSeq,
                shlfYmd: shlfYmd,
                lotNo: lotNo,
                cnfrShlfYmd: undefined,
                goodsQty: undefined,
                cnfrGoodsQty: undefined,
                cnfrUnitCd: undefined,
                cnfrUnitNm: undefined,
                goodsPrUnitCd: clone.goodsPrUnitCd,
                goodsPrUnitNm: clone.goodsPrUnitNm,
                gdslsQty: 0,
                gdslsUnitCd: clone.gdslsUnitCd,
                delYn: 'N',
            }
            clone.checkShelfs.push(nextShelf)
            setActiveShelf(nextShelf)

            setCloneData(clone)
            checkConfirm(clone)
        }
    }

    const onClickActive = (shelf: PoGoodsShelf) => {
        setActiveShelf(shelf)
    }

    const onClickDelete = () => {
        if (activeShelf) {
            activeShelf.delYn = 'Y'
            // cloneData.filter()
            const deep = cloneDeep(cloneData)
            setCloneData(deep)
            checkConfirm(deep)
        }
    }
    const onClickClose = async () => {
        const isConfirm = await $alert({
            icon: 'warn',
            title: t(tokens.common.close),
            text: t(tokens.common.if_you_leave_the_page_your_work_will_not_be_saved),
            isConfirm: true,
        })
        if (isConfirm) {
            props.onHide(false)
        }
    }

    useEffect(() => {
        if (activeShelf) {
            // setDeleteDisabled(!!activeShelf.shlfYmd)
        }
    }, [activeShelf])

    const footer = () => {
        return (
            <div className="grid">
                {props.data.shlfYn === 'Y' && (
                    <>
                        <div className="col-6 flex pl-0 mt-1 py-0">
                            <Button
                                className="w-full p-button-info"
                                label={t(tokens.common.add_item)}
                                size="large"
                                onClick={onClickAdd}
                                disabled={saveBlock}
                            />
                        </div>
                        <div className="col-6 flex pr-0 mt-1 py-0">
                            <Button
                                className="w-full p-button-danger"
                                label={t(tokens.common.remove_item_)}
                                size="large"
                                onClick={onClickDelete}
                                disabled={deleteDisabled || saveBlock}
                            />
                        </div>
                    </>
                )}

                <div className="col-6 flex pl-0">
                    <Button
                        className="w-full p-button-secondary"
                        label={t(tokens.common.close)}
                        size="large"
                        disabled={saveBlock}
                        onClick={onClickClose}
                    />
                </div>
                <div className="col-6 flex pr-0">
                    <Button
                        className={`w-full ${props.isUpdate ? 'p-button-warning' : 'p-button-success'}`}
                        label={props.isUpdate ? t(tokens.common.modify_entry_processing) : t(tokens.common.complete_entry_processing)}
                        size="large"
                        onClick={onClickSave}
                        disabled={confirmDisabled || saveBlock}
                    />
                </div>
            </div>
        )
    }

    return (
        <Dialog
            header={props.isUpdate ? t(tokens.common.modify_entry_processing) : t(tokens.common.entry_processing)}
            visible={props.visible}
            onHide={() => props.onHide && props.onHide(false)}
            footer={footer}
            closable={false}
            contentClassName="pb-0"
        >
            {props.data && (
                <div className="grid">
                    <div className="col-12 flex rdms-text-primary font-bold text-2xl mt-2">{t(tokens.common.product_name)} | {t(tokens.common.product_barcode)}</div>
                    <div className="col-12 flex text-lg mt-0 pt-0">{props.data.goodsNm} | {props.data.sysCd}</div>
                    <div className="col-12 flex rdms-text-primary font-bold text-xl mt-2 grid py-0">
                        {props.data.shlfYn === 'Y' ? (
                            <>
                                <div className="col-6">{t(tokens.common.actual_inbound_count)}</div>
                                <div className="col-6">{t(tokens.common.order_unit)}</div>
                                <div className="col-6">{t(tokens.common.lot_no)}</div>
                                <div className="col-6">{t(tokens.common.expiration_date)}</div>
                            </>
                        ) : (
                            <>
                                <div className="col-6">{t(tokens.common.actual_inbound_count)}</div>
                                <div className="col-6 px-4">{t(tokens.common.order_unit)}</div>
                            </>
                        )}
                    </div>
                    <div className="col-12 flex text-lg mt-0 p-0">
                        <ScrollPanel style={{ height: '300px' }}>
                            <div className="grid mt-1">
                                {cloneData &&
                                    cloneData.checkShelfs.map((shelf) => (
                                        <React.Fragment key={shelf.seq}>
                                            {shelf.delYn === 'N' && (
                                                <div
                                                    className={classNames({
                                                        flex: true,
                                                        'flex-wrap': true,
                                                        'px-2': true,
                                                        'border-round-2xl': true,
                                                        'bg-color-blue': isEqual(shelf, activeShelf),
                                                    })}
                                                    style={{ margin: '1px' }}
                                                    onClick={() => onClickActive(shelf)}
                                                >
                                                    {props.data.shlfYn === 'Y' ? (
                                                        <>
                                                            <div className="col-6 py-1">
                                                                <InputNumber
                                                                    inputClassName="flex w-full p-inputtext-lg"
                                                                    value={shelf.goodsQty}
                                                                    onChange={(e) => onChangeData(shelf, 'goodsQty', e.value)}
                                                                    onBlur={() => setActiveShelf(shelf)}
                                                                    maxFractionDigits={shelf.cnfrUnitCd === 'KG' ? 1 : 0}
                                                                />
                                                            </div>
                                                            <div className="col-6 py-1">
                                                                <Dropdown
                                                                    value={shelf.cnfrUnitCd}
                                                                    className="flex w-full p-inputtext-lg text-sm"
                                                                    panelClassName="p-inputtext-sm"
                                                                    options={filterTypes}
                                                                    optionValue="codeId"
                                                                    optionLabel="codeNm"
                                                                    onChange={(e) => onChangeData(shelf, 'cnfrUnitCd', e.value)}
                                                                    onSelectCapture={() => setActiveShelf(shelf)}
                                                                />
                                                            </div>
                                                            <div className="col-6 py-1">
                                                                <InputText
                                                                    value={shelf.lotNo}
                                                                    className="w-full p-inputtext-lg"
                                                                    placeholder={t(tokens.common.lot_no_input)}
                                                                    onChange={(e) => onChangeData(shelf, 'lotNo', e.currentTarget.value)}
                                                                    onBlur={() => setActiveShelf(shelf)}
                                                                />
                                                            </div>
                                                            <div className="col-6 py-1 flex" >
                                                                <Calendar
                                                                    value={shelf.shlfYmd ? moment(shelf.shlfYmd, 'YYYYMMDD').toDate() : undefined}
                                                                    className="flex w-full p-inputtext-lg"
                                                                    placeholder={t(tokens.common.expiration_date_input)}
                                                                    inputClassName="text-lg"
                                                                    minDate={moment().toDate()}
                                                                    touchUI
                                                                    dateFormat="y-mm-dd"
                                                                    onChange={(e) => onChangeData(shelf, 'shlfYmd', e.value)}
                                                                    onBlur={() => setActiveShelf(shelf)}
                                                                    onHide={() => setActiveShelf(shelf)}
                                                                />
                                                                <Checkbox
                                                                    className="ml-3 mt-1 big-checkbox"
                                                                    inputId={`no-exp-${shelf.seq}`}
                                                                    style={{ width: '40px', height: '40px' }}
                                                                    checked={shelf.shlfYmd === '99991231'}
                                                                    onChange={(e) => {
                                                                        if (e.checked) {
                                                                            // 체크 시 99991231로 설정
                                                                            onChangeData(shelf, 'shlfYmd', moment('9999-12-31').toDate())
                                                                        } else {
                                                                            // 체크 해제 시 undefined로
                                                                            onChangeData(shelf, 'shlfYmd', undefined)
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </>
                                                        ) : (
                                                        <>
                                                            <div className="col-6 py-1">
                                                                <InputNumber
                                                                    inputClassName="flex w-full p-inputtext-lg"
                                                                    value={shelf.goodsQty}
                                                                    onChange={(e) => onChangeData(shelf, 'goodsQty', e.value)}
                                                                    onBlur={() => setActiveShelf(shelf)}
                                                                />
                                                            </div>
                                                            <div className="col-6 py-1">
                                                                <Dropdown
                                                                    value={shelf.cnfrUnitCd}
                                                                    className="flex w-full p-inputtext-lg text-sm"
                                                                    panelClassName="p-inputtext-sm"
                                                                    options={filterTypes}
                                                                    optionValue="codeId"
                                                                    optionLabel="codeNm"
                                                                    onChange={(e) => onChangeData(shelf, 'cnfrUnitCd', e.value)}
                                                                    onSelectCapture={() => setActiveShelf(shelf)}
                                                                />
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            )}
                                        </React.Fragment>
                                    ))}
                            </div>
                        </ScrollPanel>
                    </div>
                </div>
            )}
        </Dialog>
    )
}

export default IncomingDetailArrivalDialog
